import Resource from '@/api/resource';

class FaqResource extends Resource {
  constructor() {
    super('faq');
  }
}

export { FaqResource as default };
